// eventBus.js
import EventEmitter from 'event-emitter';

const eventBus = new EventEmitter();

export default eventBus;